import { ArrowRight, Mail, MessageCircle } from "lucide-react";
import { Reveal, WHATSAPP_URL } from "./shared";

export const FinalCTA = () => (
    <section
        data-testid="final-cta-section"
        className="border-t border-champagne/20 bg-night py-24 text-center text-ivory lg:py-32"
    >
        <div className="mx-auto max-w-4xl px-6">
            <Reveal>
                <span className="inline-flex items-center gap-3 text-[11px] font-semibold uppercase tracking-[0.3em] text-ivory/60">
                    <span className="h-px w-8 bg-champagne" aria-hidden="true" />
                    Begin the Conversation
                    <span className="h-px w-8 bg-champagne" aria-hidden="true" />
                </span>
                <h2 className="mt-6 font-serif text-3xl font-medium tracking-tight sm:text-4xl lg:text-5xl">
                    Ready to Take the Next Step?
                </h2>
                <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-ivory/65">
                    Whether you're looking for international talent, a career opportunity, education abroad
                    or global mobility support, Afrinexa Global is ready to help.
                </p>
                <div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row">
                    <a
                        href="/recruitment"
                        data-testid="final-cta-hire-btn"
                        className="inline-flex items-center justify-center gap-2 bg-champagne px-8 py-4 text-sm font-semibold uppercase tracking-[0.1em] text-ink transition-colors hover:bg-ivory"
                    >
                        Hire Talent
                        <ArrowRight size={16} strokeWidth={1.5} />
                    </a>
                    <a
                        href="/jobs"
                        data-testid="final-cta-find-btn"
                        className="inline-flex items-center justify-center border border-ivory/30 px-8 py-4 text-sm font-semibold uppercase tracking-[0.1em] text-ivory transition-colors hover:border-ivory hover:bg-ivory/10"
                    >
                        Find Opportunities
                    </a>
                    <a
                        href="#contact"
                        data-testid="final-cta-contact-link"
                        className="inline-flex items-center justify-center px-4 py-4 text-sm font-medium text-ivory/70 underline-offset-4 transition-colors hover:text-champagne hover:underline"
                    >
                        Contact Afrinexa
                    </a>
                </div>
                <div className="mt-12 flex flex-col items-center justify-center gap-4 text-sm text-ivory/60 sm:flex-row sm:gap-8">
                    <a
                        href={WHATSAPP_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="final-cta-whatsapp-link"
                        className="inline-flex items-center gap-2 transition-colors hover:text-champagne"
                    >
                        <MessageCircle size={15} strokeWidth={1.5} />
                        +234 814 063 5506
                    </a>
                    <span className="hidden h-1 w-1 rotate-45 bg-champagne/60 sm:block" aria-hidden="true" />
                    <a
                        href="mailto:contact@afrinexaglobal.org"
                        data-testid="final-cta-email-link"
                        className="inline-flex items-center gap-2 transition-colors hover:text-champagne"
                    >
                        <Mail size={15} strokeWidth={1.5} />
                        contact@afrinexaglobal.org
                    </a>
                </div>
            </Reveal>
        </div>
    </section>
);
